import GoogleCalendarIcon from "../../../assets/icons/g-calendar.png";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import Linked from "./Linked";
import FeatureLock from "../../../components/FeatureLock/FeatureLock";
import { FEATURE_IDS } from "../../../constants/featureAccess";
import { GOOGLE_CALENDAR_ID } from "../../../data/integration-app";

const GoogleCalendar = ({connectedVenues}) => {
    return (
        <Col md="6" xxl="3" xl="4">
            <FeatureLock featureId={FEATURE_IDS.CALENDAR_INTEGRATIONS}>
                <Link to="/admin/calendar-integration" className="int-col">
                {connectedVenues.some(data => parseInt(data.app_id) === GOOGLE_CALENDAR_ID) && <Linked />} 
                <div className="img">
                    <img
                    src={GoogleCalendarIcon}
                    alt="Google Calendar"
                    />
                </div>
                <div className="text">
                    <h3>Google Calendar</h3>
                    <p>
                    Stay organized with Google Calendar — schedule meetings, events, and reminders with ease.
                    </p>
                </div>
                </Link>
            </FeatureLock>
        </Col>
    );
}

export default GoogleCalendar;
